import { render } from "./rateRequestManager.vue?vue&type=template&id=d288fe02"
import script from "./rateRequestManager.vue?vue&type=script&lang=js"
export * from "./rateRequestManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__